import { TableBlock } from '../../ds/TableBlock';
import type { UcComparisonTableSection } from '../../../lib/useCaseQueries';
import { UseCaseBand } from '../primitives';
import { UseCaseSectionHead } from '../UseCaseSectionHead';

type UcComparisonTableSectionProps = {
  data: UcComparisonTableSection;
  tone: 'light' | 'dark';
};

export function UcComparisonTableSection({ data, tone }: UcComparisonTableSectionProps) {
  return (
    <UseCaseBand tone={tone} id="comparison">
      <UseCaseSectionHead eyebrow={data.eyebrow} heading={data.heading} />
      <div className="compare-table-wrap reveal">
        {data.table && (
          <TableBlock
            value={data.table}
            variant="use-case"
            highlightedColumnIndex={1}
          />
        )}
      </div>
    </UseCaseBand>
  );
}
